<template>
  <div class="systemcs-fa">
    <el-scrollbar wrapStyle="overflow-x:hidden;" :style="`height:${scroll_height}px`">
      <div @click="clickedChange(item.label)" :class="[
        pointer ? 'systencs-item-pointer' : '',
        clicked == item.label ? 'systencs-item-pointer-clicked' : ''
      ]" class="systencs-item" v-for="(item, index) in systemlist" :key="item.label">
        <div class="systencs-item-label" style="width:50px">
          {{ index + 1 }}
        </div>
        <div class="systencs-item-label" style="text-align:left">
          {{ item.label }}
        </div>
        <div class="systencs-item-value">
          {{ item.value }}
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  name: "systemcs",
  props: ["systemcslist", "scroll_height", "pointer"],
  data() {
    return {
      clicked: -1,
      systemlist: []
    };
  },
  async mounted() {
    this.systemlist = this.systemcslist;
  },
  methods: {
    setSystem(list) {
      this.systemlist = list;
    },
    clickedChange(res) {
      if (this.pointer) {
        if (this.clicked !== res) {
          this.clicked = res;
          this.$emit("systemReturn", res);
        } else {
          this.clicked = -1;
          this.$emit("systemReturn", false);
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.systemcs-fa {
  width: 100%;
  height: 100%;
  padding: 10px;
}

.systencs-item {
  display: flex;
  align-items: center;
  height: 30px;

  .systencs-item-label {
    width: 120px;
    color: #409eff;
    text-align: center;
  }

  .systencs-item-value {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.systencs-item-pointer {
  cursor: pointer;

  &:hover {
    background-color: #d9ecff;
  }
}

.systencs-item-pointer-clicked {
  background-color: #d9ecff;
}
</style>
